import { LOGIN_DISPLAY_MAP } from '@/pages/login/constants'
import { setLoginDisplay } from '@/utils'
/**
 * 判断如何显示Login页面
 */
function useLoginDisplyGuard(router) {
  router.beforeEach(async (to, from, next) => {
    if (to.query.loginDisplay) {
      setLoginDisplay(to.query.loginDisplay)
    }
    next()
  })
}
export default useLoginDisplyGuard
